var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirplane2 = function SvgAirplane2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.637 23.274H8.534a.776.776 0 0 1-.76-.928l1.438-7.218h-2.3L5.2 16.84a.78.78 0 0 1-.545.227H2.327a.776.776 0 0 1-.72-1.066l1.436-3.588-1.436-3.588a.776.776 0 0 1 .72-1.067h2.328a.78.78 0 0 1 .549.227l1.711 1.712h2.297L7.773 2.48a.776.776 0 0 1 .76-.928h3.104a.78.78 0 0 1 .694.428l3.858 7.717h4.37a2.715 2.715 0 1 1 0 5.431h-4.37l-3.858 7.717a.78.78 0 0 1-.694.429"
  })));
};
export default SvgAirplane2;